import { Box, Typography } from "@mui/material";

import useColors from "../../../../../../api/hooks/useColors";
import TextWithExternalLink from "../../../../../../components/ExternalLink";

const GoogleAppDetailsView = ({ entityData }) => {
  const colors = useColors();

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {!entityData?.google_data?.home_page_url &&
        !entityData?.google_data?.support_email && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Typography variant={"subtitle2"}>
              No domains found for this app.
            </Typography>
          </Box>
        )}
      {entityData?.google_data?.home_page_url && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Home Page</Typography>
          </Box>
          <Box display={"flex"} ml={3}>
            <TextWithExternalLink
              text=""
              linkText={entityData?.google_data?.home_page_url}
              href={entityData?.google_data?.home_page_url}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
              linkColor={colors.text_primary}
            />
          </Box>
        </Box>
      )}
      {entityData?.google_data?.support_email && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Support Email</Typography>
          </Box>
          <Box display={"flex"} ml={3}>
            <TextWithExternalLink
              text=""
              linkText={entityData?.google_data?.support_email}
              href={`mailto:${entityData?.google_data?.support_email}`}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
              linkColor={colors.text_primary}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default GoogleAppDetailsView;
